import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=bf711dfe&scoped=true"
import script from "./comment.vue?vue&type=script&lang=ts"
export * from "./comment.vue?vue&type=script&lang=ts"
import style0 from "./comment.vue?vue&type=style&index=0&id=bf711dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf711dfe",
  null
  
)

export default component.exports